import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const HandsFreeIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1600 256q40 0 75 15t61 41 41 61 15 75v896q0 119-45 224t-124 183-183 123-224 46q-144 0-268-55t-226-156l-472-472q-28-28-43-65t-15-76q0-42 16-78t43-64 63-42 78-16q40 0 76 15t65 44l107 106V320q0-40 15-75t41-61 61-41 75-15q37 0 71 14 8-31 26-57t42-45 55-29 62-11q32 0 62 10t54 30 43 45 26 57q34-14 71-14 32 0 62 10t54 30 43 45 26 57q34-14 71-14zm64 192q0-26-19-45t-45-19q-26 0-45 19t-19 45v448q0 26-19 45t-45 19q-26 0-45-19t-19-45V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v512q0 26-19 45t-45 19q-26 0-45-19t-19-45V192q0-26-19-45t-45-19q-26 0-45 19t-19 45v640q0 26-19 45t-45 19q-26 0-45-19t-19-45V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v787q0 23-8 42t-23 35-35 23-42 9q-22 0-42-8t-37-24l-139-139q-21-21-50-21t-50 21-22 51q0 29 21 50l472 473q84 84 184 128t219 45q93 0 174-35t142-96 96-142 36-175V448z" />
    </svg>
  ),
  displayName: 'HandsFreeIcon',
});

export default HandsFreeIcon;
